/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FillingStationIssueComponent } from './fillingstationissue.page';
export const routes: Routes = [
    { path: 'fillingstationissue', component: FillingStationIssueComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        FillingStationIssueComponent
    ]
})
export class FillingStationIssueModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationissue/fillingstationissue.module.ts